import { Offering, OfferingStatus } from '@arrived/models';

export const getPercentFunded = (offering: Offering) =>
  offering.status === OfferingStatus.FUNDED ? 100 : Math.floor(offering.fundedPercentNoDebt);
